/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-line': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<g _stroke="#333" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M17.06 6.769a6.26 6.26 0 11-12.522-.001 6.26 6.26 0 0112.521 0z"/><path pid="1" d="M20.124 19.998c-1.19-4.028-4.912-6.97-9.325-6.97-4.414 0-8.135 2.942-9.326 6.97"/></g>'
  }
})
